import React from "react"
import CaseStudy from './CaseStudy';


function CaseStudies(props) {
    const {show} = props

    return (
        <React.Fragment>

        {/* Report redesign case study card */}
        {show.report ?
            <CaseStudy
                name="Underwritig Action Bar"
                desc="Giving underwriters a way to perform critical actions at any time in the underwriting process, without leaving their workflow"
                logo=""
                role="UX Designer"
                company="UWM"
                backgroundColor="#1C1C2A"
                accentColor="#A2A5D6"
                favorite={true}
            />
        : null}
        
        {/* Report redesign case study card */}
        {show.report ?
            <CaseStudy
                name="Breast Cancer Report"
                desc="Creating a personalized breast cancer report to help patients take control of their treatment"
                logo="/Summary-Options.png"
                role="Product Designer & F-E Developer"
                company="Yerbba"
                backgroundColor="#1C1C2A"
                accentColor="#A2A5D6"
                favorite={true}
            />
        : null}

        {/* AI Manual Review tool case study card */}
        {show.review ?
            <CaseStudy
                name="AI Manual Review Tool"
                desc="Creating a tool for our team to review and edit breast cancer reports generated by our AI"
                logo="/Manual-Review.png"
                role="Product Designer & F-E Developer"
                company="Yerbba"
                backgroundColor="#E2E2F0"
                textColor="#1C1C2A"
                accentColor="#5E5F7D"
                favorite={true}
            />
        : null}

        {/* Signup redesign case study card */}
        {show.signup ?
            <CaseStudy
                name="EHR Signup"
                desc="Creating a signup process that guides patients through giving access to their electronic health records"
                logo="/Yerbba-Signup.png"
                role="Product Designer & F-E Developer"
                company="Yerbba"
                backgroundColor="#1C1C2A"
                accentColor="#A2A5D6"
            />
        : null}

        {/* ShotDoctor case study card */}
        {/* {show.cards ? 
            <CaseStudy
                name="Shot Doctor Cards"
                desc="Displaying statistical inefficiencies to help college coaches make more effective adjustments"
                logo="/comparison1.png"
                role="Product Designer"
                company="ShotQuality"
                backgroundColor="#923E01"
                textColor="white"
                accentColor="#FFCDA8"
            />
        : null} */}
        </React.Fragment>
    )
}

export default CaseStudies